import React from "react";
import "./GamesLeftComponent.css"
import {Badge} from "@mui/material";

interface GamesLeftProps {
    gamesLeft: number | null
}

export const GamesLeftComponent: React.FC<GamesLeftProps> = ({gamesLeft}) => {
    // Don't show anything if gamesLeft is not loaded yet (-1) or null
    if (gamesLeft === -1 || gamesLeft === null) {
        return null;
    }

    return (
        <Badge badgeContent={gamesLeft} color="primary">
            <img
                className="coins-img"
                src={"coins.svg"}
                alt={"Free games remaining for today"}/>
        </Badge>
    )
}